module.exports = __webpack_public_path__ + "static/media/chemist-select-logo-purple-border.4d336509.png";